/**
 * 特定のバリアント（クリア（防曇）/クリア）のみをSOLDOUT表示にする
 */

(function() {
  'use strict';

  /**
   * 特定のバリアントにクラスを追加
   */
  function markSpecificVariant() {
    const lensLabels = document.querySelectorAll('.variant-input label');
    
    lensLabels.forEach(label => {
      const labelText = label.textContent.trim();
      
      // 「クリア（防曇）/クリア」を含むラベルを探す
      if (labelText.includes('クリア（防曇）/クリア') || labelText.includes('クリア(防曇)/クリア')) {
        // 親要素のvariant-inputにクラスを追加
        const variantInput = label.closest('.variant-input');
        if (variantInput) {
          variantInput.classList.add('sold-out-specific');
          label.classList.add('sold-out-specific');
        }
      }
    });
  }

  /**
   * 初期化
   */
  function init() {
    // ページ読み込み時に実行
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', markSpecificVariant);
    } else {
      markSpecificVariant();
    }

    // フレーム選択の変更を監視
    const frameRadios = document.querySelectorAll('input[type="radio"][name="フレーム"]');
    frameRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        setTimeout(markSpecificVariant, 100);
      });
    });

    // 動的に追加される要素に対応
    const observer = new MutationObserver(function(mutations) {
      markSpecificVariant();
    });

    const productForm = document.querySelector('form[action*="/cart/add"]') || 
                       document.querySelector('[data-product-form]') ||
                       document.querySelector('main');
    
    if (productForm) {
      observer.observe(productForm, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }
  }

  // 実行
  init();
})();